export default __webpack_public_path__ + "32d7228fab03b4844b3d2fe6be596c5e.png";